import React, { useState } from "react"
import ConditionSelect from "./condition-select/condition-select"
import { useEFSData } from "hooks/efs-input"

export const withDebugConditionSelector = WrappedComponent => props => {
  const [conditionSelected, setConditionSelected] = useState(false)
  const efsData = useEFSData()
  let {
    debug,
    showPicked,
    storeId,
    baselineStoreId,
    baselineCondition
  } = efsData

  const handleSelectedCondition = newCondition => {
    setConditionSelected(true)
    efsData.condition = newCondition
  }

  const handleSelectedStoreName = newStoreName => {
    efsData.storeName = newStoreName
  }

  if (showPicked) {
    debug = false
  }

  // convert condition if necessary
  if (!debug) {
    if (storeId === baselineStoreId) {
      efsData.condition = baselineCondition // hardcoded baseline
    }
  }

  return !debug || conditionSelected ? (
    <WrappedComponent {...props} />
  ) : (
    <ConditionSelect
      onConditionSet={newCondition => handleSelectedCondition(newCondition)}
      onStoreNameSet={newStoreName => handleSelectedStoreName(newStoreName)}
    />
  )
}
